import React from 'react';
import { SiteHeader } from './components/SiteHeader';
import { Hero } from './components/Hero';
import { ParentPain } from './components/ParentPain';
import { Reframe } from './components/Reframe';
import { ChildRecognition } from './components/ChildRecognition';
import { WhyItMatters } from './components/WhyItMatters';
import { Transformation } from './components/Transformation';
import { ToolkitIntro } from './components/ToolkitIntro';
import { LookInside } from './components/LookInside';
import { WhatsIncluded } from './components/WhatsIncluded';
import { ParentFeedback } from './components/ParentFeedback';
import { OfferStack } from './components/OfferStack';
import { Faq } from './components/Faq';
import { FinalClose } from './components/FinalClose';
import { Footer } from './components/Footer';
type AppProps = {
  /** Turn on once real interior page screenshots are added to previewSlots in data/content.ts. */
  showLookInside?: boolean;
};
export function App({
  showLookInside = false
}: AppProps) {
  return <div className="w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="3iiwfuqnezm4a">
      <SiteHeader data-id="element-1" data-mp="3mlj82snzz920" />
      <main data-id="element-2" data-mp="3ml12h5fg3ihf">
        <Hero data-id="element-3" data-mp="3mkhlbqxmcy4g" />
        <ChildRecognition data-id="element-4" data-mp="3mk83iqmq9x9u" />
        <ParentPain data-id="element-5" data-mp="3mjg8pi0yg3km" />
        <WhyItMatters data-id="element-6" data-mp="3rcj6618urx63" />
        <Reframe data-id="element-7" data-mp="3rbzo8kj7d8s2" />
        <Transformation data-id="element-8" data-mp="3rdkg22e4udm8" />
        <ToolkitIntro data-id="element-9" data-mp="3recdzjv7cnfo" />
        {showLookInside && <LookInside data-id="element-10" data-mp="6hq1ea16ddl" />}
        <WhatsIncluded data-id="element-11" data-mp="4n4bxqxqh8g" />
        <ParentFeedback data-id="element-12" data-mp="56l3b4umzkw" />
        <OfferStack data-id="element-13" data-mp="2zl3azit8d249" />
        <Faq data-id="element-14" data-mp="2zllcouynw8jk" />
        <FinalClose data-id="element-15" data-mp="2zm4ywnvchj3e" />
      </main>
      <Footer data-id="element-16" data-mp="2zmwh8wzxlkbq" />
    </div>;
}